module.exports = __webpack_public_path__ + "img/logo-mobile.520679d2.svg";